import { render, staticRenderFns } from "./PreferenceItem.vue?vue&type=template&id=2f34e98e&scoped=true&"
import script from "./PreferenceItem.vue?vue&type=script&lang=js&"
export * from "./PreferenceItem.vue?vue&type=script&lang=js&"
import style0 from "./PreferenceItem.vue?vue&type=style&index=0&id=2f34e98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34e98e",
  null
  
)

component.options.__file = "PreferenceItem.vue"
export default component.exports